export default {
    data() {
        return {
            keyword: '',
        };
    },
    methods: {
        seach() {
            if (!this.keyword) return
            this.$router.push({
                name: 'searchresults',
                query: {
                    keyword: this.keyword
                }
            })
            this.keyword = '';
        }
    },
}